import { useHistory } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageHeader from '@features/PageHeader';
import Button from '@components/Button';
import { IntegrationRequiredIcon } from 'assets/images/icons';
import { useTranslation } from '@hooks';
import { ROLE } from '@constants/user';
import { ExternalRoutes, RoutePath } from '@constants/routes';

const IntegrationRequired = ({ googleOnly = false }) => {
    const { t } = useTranslation();
    const history = useHistory();
    const user = useSelector(state => state.auth.user);

    const onClickLearnMore = () => {
        window.open(ExternalRoutes.IntegrationLearnMore[user?.language], '_blank');
    };

    return (
        <PageHeader
            icon={<IntegrationRequiredIcon />}
            title={t('IntegrationRequired.title')}
            subtitle={t(`IntegrationRequired.${googleOnly ? 'subtitleGoogle' : 'subtitleCommon'}`)}
            styles={{ marginBottom: '16px' }}
        >
            {user?.role === ROLE.SUPER_ADMIN && (
                <Button variant="contained" onClick={() => history.push(RoutePath.AccountSettingsIntegrations)}>
                    {t('buttons.connect')}
                </Button>
            )}
            <Button variant="outlined" onClick={onClickLearnMore}>
                {t('common.learnMore')}
            </Button>
        </PageHeader>
    );
};

export default IntegrationRequired;
